import { render, staticRenderFns } from "./PaginationSkeleton.vue?vue&type=template&id=523e9fa8&scoped=true&"
var script = {}
import style0 from "./PaginationSkeleton.vue?vue&type=style&index=0&id=523e9fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e9fa8",
  null
  
)

export default component.exports